import { useUsersStore } from '@/store/users';
import { useOrganizationsStore } from '@/store/organizations';
import { useInfluencersStore } from '@/store/influencers';

export const influencersOptions = {
  searchUsers: async (query: string | Record<string, any> = '') => {
    const store = useUsersStore();
    await store.searchUsers(query);
    return store.users_result;
  },
  searchOrganizations: async (query: string | Record<string, any> = '') => {
    const store = useOrganizationsStore();
    await store.fetchOrganizations(query);
    return store.organizations || [];
  },
  searchInfluencers: async (query: string | Record<string, any> = '') => {
    const store = useInfluencersStore();
    await store.searchInfluencers(query);
    return store.influencers_search;
  },
};
